const CopiedIcon = () => {
    
    return (
        <svg width="100%" height="100%" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM6.0466 9.13754L7.73667 10.5628L12.2372 6.01799C12.4239 5.82946 12.7278 5.82705 12.9174 6.01259C13.1087 6.19971 13.1112 6.50676 12.9229 6.69693L8.2022 11.4655C7.97318 11.6968 7.60494 11.7136 7.35579 11.5041L5.42263 9.8785C5.21811 9.70652 5.19152 9.4014 5.3632 9.19663C5.5354 8.99122 5.8417 8.96474 6.0466 9.13754Z" fill="currentColor" />
        </svg>
    );
};

export default CopiedIcon;
